var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.459 3.53632C18.1366 1.2149 15.0683 0 12 0C8.93172 0 5.86325 1.2149 3.54097 3.53632C-1.18032 8.25641 -1.18032 15.7295 3.54097 20.4494C5.87753 22.7851 8.93172 24 12 24C15.0683 24 18.1225 22.7851 20.459 20.4494C25.1803 15.7295 25.1803 8.25641 20.459 3.53632ZM5.5255 5.52045C7.31314 3.74744 9.64952 2.78595 12 2.78595C13.8439 2.78595 15.7016 3.39569 17.3063 4.53552L12 9.84009L4.54029 17.2976C1.8984 13.5657 2.2856 8.77368 5.5255 5.52045ZM18.4743 18.4655C16.6869 20.2385 14.3505 21.2 12 21.2C10.1561 21.2 8.29835 20.5902 6.69369 19.4504L19.4597 6.68829C22.1014 10.42 21.7144 15.212 18.4743 18.4655Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableGrey);
export default __webpack_public_path__ + "static/media/disable-grey.18c59ad7a3a52498f904deb30d666cb9.svg";
export { ForwardRef as ReactComponent };